const animationDurations = {
    // one beat for every animated transition - cross-fades, the height spring, a container's own shape -
    // so the pieces of a single change never drift apart. Mirrored by the `duration-200` Tailwind class
    STATE_CHANGE_MS: 200,
    // the longest frame a frame-driven animation integrates: a tab coming back from the background must
    // not snap the animation into a pose it never travelled through
    MAX_FRAME_MS: 100,
};

export default animationDurations;
